<div class="table-header-wrapper">
  @if (hasHeader) {
    <ion-row class="table-header ion-align-items-center">
      <div ngClass="{'alt-header':hasAltHeader}" class="header-text">
        {{ headerText }}
      </div>
    </ion-row>
  }

  <ion-row class="table-icon-header ion-align-items-end">
    @if (hasSearchBar || hasRadioButton) {
      <ion-col class="ion-no-padding left-icons" size="6">
        @if (hasShowingResultsText) {
          {{
            DISP_CONSTANTS.SHOWING_RESULTS.replace("%s", numResults.toString())
          }}
        }
        @if (hasSearchBar) {
          <app-header-search
            #searchHeader
            [isDisabled]="searchBarDisabled"
            (emitTextChange)="sendSearchSignal($event)"
            (emitClearChange)="sendSearchClear()"
          ></app-header-search>
        }
        <ng-content></ng-content>
        @if (hasRadioButton) {
          <app-radio-button
            [isDisabled]="radioButtonDisabled"
            [header]="radioHeader"
            [radioModel]="radioModel"
            [firstOptionValue]="firstOptionValue"
            [firstOptionName]="firstOptionName"
            [secondOptionValue]="secondOptionValue"
            [secondOptionName]="secondOptionName"
            (buttonChange)="sendRadioButtonChange($event)"
          ></app-radio-button>
        }
      </ion-col>
    }
    <ion-col
      class="ion-no-padding right-icons"
      [size]="hasSearchBar || hasRadioButton ? 6 : 12"
    >
      @if (hasFilter && !hasNoButtons) {
        <app-filter-icon
          [isDisabled]="filterDisabled"
          (clearFilterEvent)="sendFilterSignal()"
        >
        </app-filter-icon>
      }
      @if (hasExcel && !hasNoButtons) {
        <app-excel-icon
          [isDisabled]="excelDisabled"
          (exportExcelEvent)="sendExportExcelSignal()"
        ></app-excel-icon>
      }
      @if (hasAddItem && !hasNoButtons) {
        @if (hasAlternateAddItem) {
          <app-action-button
            alt="add-stop"
            class="action-button"
            [src]="IMAGES.DELIVERY_BUTTON"
            [buttonText]="addButtonText"
            (addItem)="sendAddItemSignal(true)"
          ></app-action-button>
          <app-action-button
            alt="add-stop"
            class="action-button"
            [src]="IMAGES.PICKUP_BUTTON"
            [buttonText]="alternateAddButtonText"
            (addItem)="sendAddItemSignal(false)"
          ></app-action-button>
        } @else if (hasSingleAlternateAddItem && !hasAlternateAddItem) {
          <!-- MAKE THIS CLEANER! -->
          <app-action-button
            alt="add-stop"
            class="action-button"
            [src]="alternateAddItemSrc"
            [buttonText]="alternateAddButtonText"
            (addItem)="sendAddItemSignal(false)"
          ></app-action-button>
        } @else {
          <app-new-item-icon
            [isDisabled]="addItemDisabled"
            (addItem)="sendAddItemSignal(true)"
          ></app-new-item-icon>
        }
      }
    </ion-col>
  </ion-row>
</div>
